export * from './page.component'